import React from 'react'
import {ClockIcon} from '../icons'
import {useRapidDeliveryStore} from '../../store/hooks/useStore'
import {Flex, Text} from '../../vanilla'

interface RapidDeliveryETAProps {
  isBasket?: boolean
  popover?: boolean
  isMiniBasket?: boolean
  isCheckout?: boolean
  variant?: 'default' | 'bookDelivery'
  compact?: boolean
  isHomepage?: boolean
}

export const RapidDeliveryETA = ({
  isBasket,
  popover,
  isMiniBasket,
  isCheckout,
  variant = 'default', 
  compact,
  isHomepage
}: RapidDeliveryETAProps) => {
  const {rapidDeliveryETAForCurrentBasket: eta} = useRapidDeliveryStore()
  const noLineBreak = isBasket || popover || isCheckout || isHomepage

  if (variant === 'bookDelivery') {

    return (
      <Flex
        gap="4px"
        alignItems="center"
        marginLeft={['8px', '12px']}
      >
        <ClockIcon
          color="gray1000"
          boxSize="16px"
          flexShrink="0"
          alignSelf={['flex-start', 'center']}
          marginTop={['4px', '0px']}
        />
        <Text variant="text3" color="gray1000" data-test-selector="rapid-delivery-eta-message">
          Delivery in the next <span style={{fontWeight: 600}}>{eta} mins</span>
        </Text>
      </Flex>
    )
  }

  return (
    <Text variant={compact ? 'text2' : isBasket || popover || isHomepage ? "text4" : "text3"} data-test-selector='rapid-delivery-eta' lineHeight={compact ? 'short' :isMiniBasket ? "shorter" : "none"}>
      Today, {!noLineBreak && <br/>}within {eta} mins
    </Text>
  )
}